<template>
  <div class="home">
    <nav class="navbar">
      <div class="navbar__left">
        <img alt="logo" src="../../assets/logo_quick_pay_2022.png" style="margin: 0 auto;">
      </div>
      <div class="navbar__center">
        <ul>
          <li @click="changePage('/comercial')">Datos Comerciales</li>
          <li   @click="changePage('/Incidencias')">Incidencias</li>
          <li @click="changePage('/InboxSugerences')">Buzón de sugerencias</li>
          <li  @click="changePage('/ClientesB2C')">Clientes</li>
          <li class="active" @click="changePage('/UsuariosB2B')">Usuarios</li>
          <li  @click="changePage('/Indicators/productos')">Indicadores</li>
          <li @click="changePage('/CargaArchivos')">Conciliación</li>
        </ul>
      </div>
      <div class="navbar__right">
        <div class="profile">
          <div class="profile__icon">
            <i class="far fa-user-circle"></i>
          </div>
          <div class="profile__detail">
            <p>{{usuario}}</p>
            <span>{{fecha}}</span>
          </div>
          <div @click="handleClick" class="profile__logout">
            <i class="fas fa-sign-out-alt"></i>
          </div>
        </div>
      </div>
    </nav>
    <div class="body">
      <div class="body__sidebar" id="body__sidebar">
        <hidden-arrow></hidden-arrow>
        <div class="title">
          <div class="title__icon">
            <i class="fas fa-home"></i>
          </div>
          <div class="title__text">
            <h2>Menu QuickPay</h2>
            <p>Selecciona una opción</p>
          </div>
        </div>
        <div class="tabs">
          <router-link to="/UsuariosB2B" class="tab">
            <div class="tab__icon">
              <i class="fas fa-globe"></i>
            </div>
            <div class="tab__text">
              <p>Usuarios B2B</p>
            </div>
          </router-link>
          <router-link to="/UsuariosB2C" class="tab active">
            <div class="tab__icon">
              <i class="fas fa-shopping-bag"></i>
            </div>
            <div class="tab__text">
              <p>Usuarios B2C</p>
            </div>
          </router-link>
        </div>
      </div>
      <div class="body__containt">
        <div class="page__title">
          <open-arrow></open-arrow>
          <h2>Usuarios B2C / Editar Usuarios</h2>
        </div>
        <div class="page__filters">
          <input type="text" placeholder="Código de Tienda">
          <input type="text" placeholder="Alias">
          <input type="text" placeholder="País">
          <input type="text" placeholder="Provincia">
          <input type="text" placeholder="Distrito">
          <input type="text" placeholder="Estado">
        </div>
        <div class="page__buttons">
          <button class="button">Nueva Sucursal <i class="fas fa-plus"></i></button>
          <button class="button">Carga Masiva <i class="fas fa-upload"></i></button>
          <button class="button">Exportar <i class="fas fa-chevron-down"></i></button>
        </div>
        <div class="page__table">
          <div class="table-headers">
            <p>Código de cliente</p>
            <p>Nombres</p>
            <p>Apellidos</p>
            <p>Correo electronico</p>
            <p>Celular</p>
            <p>Fecha nacimiento</p>
            <p>Token</p>
            <p>Estado</p>
            <p>Accion</p>
          </div>
          <div class="table-body">
            <div class="data" v-for="branch of branchoffice" v-bind:key="branch.id">
              <p>{{ branch.id }}</p>
              <p>{{ branch.client_name }}</p>
              <p>{{ branch.client_lastname}}</p>
              <p>{{ branch.client_email}}</p>
              <p>{{ branch.client_cellphone}}</p>
              <p>{{ branch.created_at}}</p>
              <p v-if="branch.client_status = 1">Si</p>
              <p v-else>No</p>
              <p v-if="branch.client_status = 1">Si</p>
              <p v-else>No</p>
              <Dropdown :id="branch.id" :type="this.type"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
// @ is an alias to /src
import axios from "axios";
import Dropdown from '@/components/Dropdown.vue'
import OpenArrow from '@/components/OpenArrow.vue'
import HiddenArrow from '@/components/HiddenArrow.vue'
export default {
  name: 'EditUsuariosB2C',
  components: {
    Dropdown,
    OpenArrow,
    HiddenArrow
  },
  data() {
    return {
      branchoffice:[],
      type: 'UsuariosB2C',
      id:'',
      fecha: '',
      usuario: '',
    }
  },
  created() {
    const valores = window.location.search;
    const urlParams = new URLSearchParams(valores);
    this.id = urlParams.get('id');
    this.getall();
    this.usuario = localStorage.getItem('usuario');
    this.getDate();
  },
  computed:{
    incidenceData:  function () {
      let temp = [];
      let result =  axios
          .get("general/incidence")
          .then(res => {
            res.data.data.forEach(item =>{
              axios.get("general/client/"+ item.user_id).then(resUser => {
                item.nameUser= resUser.data.data.client_name;
                item.lastname= resUser.data.data.client_lastname;
                item.cellphone= resUser.data.data.client_cellphone;
                temp.push(item);
              })
              return temp;
            })
          })

    }
  },
  getDate() {
      let dias = [
        'Lunes',
        'Martes',
        'Miercoles',
        'Jueves',
        'Viernes',
        'Sabado',
        'Domingo'
      ]
      let meses = [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre'
      ]

      let date = new Date()

      var fechaNum = date.getDate()
      var mes_name = date.getMonth()

      this.fecha =
          dias[date.getDay() - 1] +
          ' ' +
          this.zeroFill(fechaNum, 2) +
          ' de ' +
          meses[mes_name]
    },
    zeroFill(number, width) {
      width -= number.toString().length
      if (width > 0) {
        return (
            new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number
        )
      }
      return number + ''
    },
    url(path) {
      this.$router.push(path)
    },
  methods:{
    changePage(url) {
      this.$router.push(url)
    },
    handleClick(){
      localStorage.removeItem('token')
      this.$router.push('/login')
    },
    backCompany(){
      this.$router.push('/comercial')
    },
    addBranchOffice(){
      this.$router.push('/addbranchoffice')
    },
    async getall(){
      // let temp = [];
      // let result = await axios
      //     .get("general/incidence")
      //     .then(res => {
      //       res.data.data.forEach(item =>{
      //         axios.get("general/client/"+ item.user_id).then(resUser => {
      //           item.nameUser= resUser.data.data.client_name;
      //           item.lastname= resUser.data.data.client_lastname;
      //           item.cellphone= resUser.data.data.client_cellphone;
      //           temp.push(item);
      //         })
      //         console.log(temp);
      //         this.branchoffice = temp;
      //       })
      //     })
      const { data } = await axios.get('general/client');


      this.branchoffice = data.data;
    }
  }
}


</script>

<style scoped>
.back_company {
  background: #000;
  color: white;
  width: 100%;
  padding-top: 3%;
  padding-left: 10%;
}

/*------NAVBAR------*/
.home {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: 'Readex Pro', sans-serif;
}

.home .navbar {
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #dbdbdb;
  box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.05);
}

.home .navbar__left {
  width: 200px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.home .navbar__left img {
  width: 130px;
}

.home .navbar__center {
  width: 70%;
  height: 100%;
}

.home .navbar__center ul{
  width: 100%;
  height: 100%;
  display: flex;
  list-style: none;
  display: flex;
  justify-content: flex-start;
}
.home .navbar__center ul li {
  text-decoration: none;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px;
  position: relative;
  cursor: pointer;
}

.home .navbar__center ul li.active {
  color: #ff3128;
}
.home .navbar__center ul li.active::before {
  width: 100%;
}

.home .navbar__center ul li::before {
  content: '';
  position: absolute;
  bottom: 0;
  width: 0;
  height: 4px;
  background-color: #ff3128;
  transition: .3s ease;
}
.home .navbar__center ul li:hover {
  color: #ff3128;
}
.home .navbar__center ul li:hover::before {
  width: 100%;
}

.home .navbar__right {
  display: flex;
}
.home .navbar__right .profile {
  display: flex;
  width: 300px;
  height: 100%;
}

.home .navbar__right .profile__detail{
  width: 220px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 5px;
}
.home .navbar__right .profile__detail p {
  margin: 0;
}
.home .navbar__right .profile__detail span {
  color: #938f8f;
  font-weight: 300;

}

.home .navbar__right .profile__icon,
.home .navbar__right .profile__logout {
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 25px;
  color: #ff3128;
  cursor: pointer;
}
/*------NAVBAR------*/

/*-------------------------*/
/*-------------------------*/

/*------BODY------*/

.body {
  width: 100%;
  height: 600px;
  display: flex;

}
.body__sidebar,
.body__containt  {
  height: calc(100vh - 120px);
  box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.1);
}
.body__sidebar {
  width: 400px;
  position: relative;
  display: flex;
  flex-direction: column;
}

.body__sidebar .floating-icon {
  position: absolute;
  right: -15px;
  top: 50px;
  color: #ff3128;
  font-size: 30px;
}

.body__sidebar .title {
  width: 100%;
  height: 140px;
  border-bottom: 1px solid #b6b6b6;
  display: flex;
  align-items: center;
  justify-content: center;
}
.body__sidebar .title__icon {
  color: #ff3128;
  font-size: 20px;
}
.body__sidebar .title__text {
  margin: 0 10px;

}

.body__sidebar .title__text h2 {
  font-size: 20px;
  margin: 0;
}
.body__sidebar .title__text p {
  margin: 0;
  font-weight: 300;
}

.body__sidebar .tabs {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 140px);
  padding-top: 5px;
}

.body__sidebar .tabs .tab {
  width: 90%;
  height: 70px;
  border-radius: 10px;
  color: #707070;
  display: flex;
  align-items: center;
  padding: 0 20px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: 0.3 ease;
}
.body__sidebar .tabs .tab:hover,
.body__sidebar .tabs .tab.active {
  color: #ff3128;
  background: #ffeeed;
}

.body__sidebar .tabs .tab__icon {
  font-size: 20px;
  margin-right: 10px;
}

.body__sidebar .tabs .tab__text p{
  margin: 0;
  font-weight: 600;
}

.body__containt {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
}

.body__containt .page__title {
  width: 100%;
  margin-bottom: 20px;
}

.body__containt .page__title h2 {
  font-weight: 600;
  color: #ff3128;
  font-size: 25px;
}

.body__containt .page__filters {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 20px;
}
.body__containt .page__filters input {
  border-radius: 10px;
  border: 1px solid #e4e4e4;
  background: #fff;
  padding: 15px 20px;
  /* margin: 0 10px; */
}

.body__containt .page__buttons {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 20px;
}

.body__containt .page__buttons .button {
  width: 250px;
  padding: 15px 20px;
  border-radius: 15px;
  font-size: 17px;
  color: #fff;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.body__containt .page__buttons .button:nth-child(1) {
  background: #32ba7c;
}
.body__containt .page__buttons .button:nth-child(2) {
  background: #ff3128;
}
.body__containt .page__buttons .button:nth-child(3) {
  background: #262626;
}

.body__containt .page__table {
  width: 100%;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  margin-top: 50px;
}

.body__containt .page__table .table-headers {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #b6b6b6;
}
.body__containt .page__table .table-headers p {
  width: calc(100% / 7);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
}

.body__containt .page__table .table-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #b6b6b6;
}

.body__containt .page__table .table-body .data {
  width: 100%;
  display: flex;
}
.body__containt .page__table .table-body .data p {
  width: calc(100% / 7);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 300;
  margin: 10px 0;
}
.body__containt .page__table .table-body .data p:nth-child(1) {
  color: #ff3128;
}
/* .body__containt .page__filters input:nth-child(1) {
  width: 300px;
  margin: 0;
  margin-right: 10px;
} */


/*------BODY------*/
  .body__sidebar.open{
    display: none;
  }



</style>
